import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from './Button';
import '../../shared/css/Tab.css';
/**
 * # Tab
 * A component to represent a navigational tab.
 *
 * [See Documentation](https://themeable.systems/documentation)
 *
 * ---
 *
 * ### Style props:
 * `icon1`: Leading or top icon.
 * `icon2`: Trailing or bottom icon.
 *
 * `title`: Text content of the tab.
 *
 * `small`: Renders the tab in a smaller size.
 *
 * `indicator`: Position of the tab's active indicator.
 *
 * `stacked`: Makes the align of the tab content stacked vertically, rather than horizontally
 *
 * ---
 *
 * ### Functional props:
 *
 * `active`: Determines if the tab is currently active.
 *
 * `onClick`: Click event handler for the tab.
 *
 * `type`: Determines if the tab is a `link` or `button`.
 *
 * `svgPath`: If icons.svg is in a different directory.
 *
 * `url`: If `type = link`, this prop determines the URL the link goes to.
 *
 * `onClick`: Function that can be passed in if type=`button` to trigger a function.
 */
var Tab = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'button' : _b, url = _a.url, iconLeading = _a.iconLeading, iconTrailing = _a.iconTrailing, _c = _a.stacked, stacked = _c === void 0 ? false : _c, title = _a.title, small = _a.small, _d = _a.indicator, indicator = _d === void 0 ? 'top' : _d, _e = _a.active, active = _e === void 0 ? false : _e, _f = _a.width, width = _f === void 0 ? 'hug' : _f, onClick = _a.onClick;
    // Calculate the final className based on the indicator prop
    var indicatorClass = '';
    if (active && indicator !== 'none') {
        indicatorClass = " indicator-".concat(indicator);
    }
    return (_jsx("div", { className: "tab".concat(indicatorClass, " v-stack middle width-").concat(width), children: _jsx(Button, { iconLeading: iconLeading, width: width, title: title, iconTrailing: iconTrailing, variant: active ? 'tertiary-preferred' : 'quaternary', small: small, 
            // @ts-ignore
            onClick: onClick, stacked: stacked, url: url, type: type }) }));
};
Tab.displayName = "Tab";
export { Tab };
